<template>
  <div class="grid">
    <cta :item="item" :theme="theme" />

    <animation
      v-model="animation"
      :options="animationOptions"
    />

    <div class="tb-form-group">
      <label class="tb-label">Cycle speed</label>

      <input
        type="number"
        class="tb-input"
        :value="getNiceTime(getField('displayTime'))"
        data-entity="producer-editor-displayTime"
        @keyup.right.stop
        @keyup.left.stop
        @change="setNiceTime('displayTime', $event.target.value)"
      >

      <span class="help-text">Range: 1 - 100 seconds</span>
    </div>

    <background :item="item" :theme="theme" />
  </div>
</template>

<script lang="js">
import editingMixins from '../../../../mixins/editing-mixins';

import Cta from '../../shared/Cta.vue';
import Background from '../../shared/Background.vue';
import Animation from '../../shared/Animation.vue';

export default {
  mixins: [editingMixins],

  components: {
    Cta,
    Background,
    Animation,
  },

  data() {
    return {
      animationOptions: [
        'Fade',
        'Slide',
        'Slide Down',
        'Flip',
      ],
    };
  },

  created() {
    if (!this.item.fields) {
      this.$set(this.item, 'fields', {});
    }
  },
};
</script>
